/**
 * contributionStore.ts
 * Module-level persistent store for Contribution Categories.
 * Shared between ContributionConfig (settings) and MemberDetailModal (add contribution).
 */

export type PointsSubjectType = 'award' | 'deduct'

export interface ContributionCategory {
  id: string;
  name: string;
  unit: string;
  pointsPerUnit: number;
  description: string;
  /** award=增加科目 deduct=扣除科目；默认 award */
  subjectType: PointsSubjectType;
  isActive: boolean;
  createdAt: string;
}

const listeners = new Set<() => void>();

const _categories: ContributionCategory[] = [];

function notify(): void {
  listeners.forEach((fn) => fn());
}

export const contributionStore = {
  getAll: (): ContributionCategory[] => [..._categories],

  getActive: (): ContributionCategory[] =>
    _categories.filter((c) => c.isActive && (c.subjectType ?? 'award') !== 'deduct'),

  add: (item: ContributionCategory) => {
    _categories.push(item);
    notify();
  },

  update: (id: string, changes: Partial<ContributionCategory>) => {
    const idx = _categories.findIndex((c) => c.id === id);
    if (idx !== -1) Object.assign(_categories[idx], changes);
    notify();
  },

  remove: (id: string) => {
    const idx = _categories.findIndex((c) => c.id === id);
    if (idx !== -1) _categories.splice(idx, 1);
    notify();
  },

  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  replaceFromApi(items: ContributionCategory[]): void {
    _categories.length = 0;
    for (const c of items) {
      _categories.push({ ...c });
    }
    notify();
  },
};
